import { Controller } from "@hotwired/stimulus"
import "jquery"

export default class extends Controller {
  static targets = [
    "finishProduct",
    "costPerProduct",
    "weightPerProduct",
    "totalCost",
    "unitField"
  ]

  connect() {
    this.productData = new Map()
    this.initializeSelect2Handlers()
  }

  initializeSelect2Handlers() {
    if (this.hasFinishProductTarget) {
      // Use event delegation or wait for Select2 to be ready
      // Select2 might be initialized by the products controller, so we need to ensure our handler is attached
      const selectElement = this.finishProductTarget
      
      // Attach handlers using jQuery (works with Select2)
      $(selectElement).on('select2:select', (event) => {
        console.log('Bolt Product Calculator - Select2 select event triggered for product ID:', event.params.data.id)
        this.handleProductChange(event.params.data.id)
      })

      $(selectElement).on('select2:clear', () => {
        console.log('Bolt Product Calculator - Select2 clear event triggered')
        this.clearFields()
      })
      
      // Also listen to regular change events as a fallback
      selectElement.addEventListener('change', (e) => {
        if (e.target.value) {
          console.log('Bolt Product Calculator - Regular change event triggered for product ID:', e.target.value)
          this.handleProductChange(e.target.value)
        } else {
          this.clearFields()
        }
      })
    }
  }

  async handleProductChange(productId) {
    const companyId = this.element.dataset.companyId

    if (!productId) {
      this.clearFields()
      return
    }

    if (!this.productData.has(productId)) {
      try {
        const response = await fetch(`/api/v1/companies/${companyId}/finish_products/${productId}`)
        const data = await response.json()
        this.productData.set(productId, {
          price: data.price,
          boltProduct: data.bolt_product,
          boltProductionCost: data.bolt_production_cost,
          boltProductionWeight: data.bolt_production_weight,
          nonBoltProductionWeight: data.non_bolt_production_weight,
          unit: data.unit,
        })
      } catch (error) {
        console.error('Error fetching product data:', error)
        return
      }
    }

    const productInfo = this.productData.get(productId)
    console.log('Bolt Product Calculator - Product Info:', productInfo)
    console.log('Bolt Product Calculator - Using finish product price:', productInfo.price, 'instead of bolt production cost:', productInfo.boltProductionCost)
    this.updateFields(productInfo)
  }

  updateFields(productInfo) {
    if (!productInfo) {
      this.clearFields()
      return
    }

    // Set weight per product from production config
    if (this.hasWeightPerProductTarget) {
      if (productInfo.boltProduct) {
        this.weightPerProductTarget.value = productInfo.boltProductionWeight || ""
      } else {
        this.weightPerProductTarget.value = productInfo.nonBoltProductionWeight || ""
      }
    }

    // Set unit field for reference
    if (this.hasUnitFieldTarget && productInfo.unit) {
      this.unitFieldTarget.value = productInfo.unit.charAt(0).toUpperCase() + productInfo.unit.slice(1)
    }

    // Always use finish product price for cost_per_product, even if it has bolt production
    // This makes sense for unfinish products where we want to use the selling price
    const finishProductPrice = parseFloat(productInfo.price) || 0
    const boltProductionCost = parseFloat(productInfo.boltProductionCost) || 0
    
    console.log('Bolt Product Calculator - Setting cost_per_product to finish product price:', finishProductPrice, '(not bolt production cost:', boltProductionCost, ')')
    
    if (this.hasCostPerProductTarget) {
      this.costPerProductTarget.value = finishProductPrice.toFixed(2)
      console.log('Bolt Product Calculator - Updated cost_per_product field to:', this.costPerProductTarget.value)
      // Trigger change event to update any dependent calculations
      this.costPerProductTarget.dispatchEvent(new Event('change', { bubbles: true }))
      this.costPerProductTarget.dispatchEvent(new Event('input', { bubbles: true }))
    }
  }

  clearFields() {
    // Clear cost per product
    if (this.hasCostPerProductTarget) {
      this.costPerProductTarget.value = ""
    }

    // Clear weight per product
    if (this.hasWeightPerProductTarget) {
      this.weightPerProductTarget.value = ""
    }

    // Clear unit field
    if (this.hasUnitFieldTarget) {
      this.unitFieldTarget.value = ""
    }

    // Clear total cost
    if (this.hasTotalCostTarget) {
      this.totalCostTarget.value = ""
    }

    // Clear quantity field (if it exists in the form)
    const quantityField = this.element.querySelector('input[name*="[quantity]"]')
    if (quantityField) {
      quantityField.value = ""
    }
  }
}
